import {
    LIST_NOTIFICATIONS,
    LIST_NOTIFICATIONS_SUCCESS,
    LIST_NOTIFICATIONS_ERROR,
    ADD_NOTIFICATIONS,
    SAVE_NOTIFICATIONS,
    SAVE_NOTIFICATIONS_SUCCESS,
    SAVE_NOTIFICATIONS_ERROR,
    EDIT_NOTIFICATIONS,
    UPDATE_NOTIFICATIONS,
    UPDATE_NOTIFICATIONS_SUCCESS,
    UPDATE_NOTIFICATIONS_ERROR,
    DELETE_NOTIFICATIONS,
    DELETE_NOTIFICATIONS_SUCCESS,
    DELETE_NOTIFICATIONS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    notifications: null,
    error: null,
    loading: false,
    notificationSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_NOTIFICATIONS:
            return {
                ...state,
                loading: true
            }
        case LIST_NOTIFICATIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                notifications: action.payload
            }
        case SAVE_NOTIFICATIONS:
        case DELETE_NOTIFICATIONS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_NOTIFICATIONS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_NOTIFICATIONS_ERROR:
        case UPDATE_NOTIFICATIONS_ERROR:
        case DELETE_NOTIFICATIONS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                notifications: [action.payload.notificacion, ...state.notifications]
            }
        case ADD_NOTIFICATIONS:
            return {
                ...state,
                notificationSelected: null,
                isEdit: false
            }
        case EDIT_NOTIFICATIONS:
            return {
                ...state,
                notificationSelected: action.payload,
                isEdit: true
            }
        case UPDATE_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                notifications: state.notifications.map(notification => 
                    notification.id === action.payload.id ? notification = {...notification, realizado: true} : notification
                ),
                notificationselected: null
            }
        case DELETE_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                notifications: state.notifications.filter( notification => notification.id !== action.payload)
            }
        default:
            return state;
    }
}